<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${img})`}">
			<div class="container">
				<div class="breadcrumb-content text-center">
					<h2>案例</h2>
				</div>
			</div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
			<div class="container" v-if="cateList.length>0">
				<div class="project-menu-style project-menu-active isotope-btn-add-active mb-6">
					<button v-for="(item,index) in cateList" :key="index" :class="cateIndex==item.id?'active':''"
						class="btn-project" data-filter="*"
						@click="clickCate(item.id,index)">{{item.cate_name}}</button>
				</div>
				<div class="project-menu-style project-menu-active isotope-btn-add-active mb-6"
					v-if="cateList[childrenIndex].children && cateList[childrenIndex].children.length>0">
					<button v-for="(item2,index2) in cateList[childrenIndex].children" :key="index2"
						:class="cateChildrenIndex==item2.id?'childrenActive':''" class="btn-project cp" data-filter="*"
						@click="clickChildrenCate(item2.id)">{{item2.cate_name}}</button>
				</div>

				<div class="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 grid">
					<div class="col mb-6 grid-item cat2 cat4" v-for="(item,index) in projectList" :key="item.id">
						<div class="project-wrap">
							<div class="project-inner">
								<router-link :to="{path:'/projectDetail/'+item.id}" class="thumbnail">
									<img :src="item.image | imgfilter" alt="Blog Image"
										style="height: 370px;object-fit: cover;">
								</router-link>
								<div class="project-content d-flex">
									<div style="flex: 1;">
										<div style="font-size: 18px;">
											<router-link :to="{path:'/projectDetail/'+item.id}" class="thumbnail">
												<div>{{item.name}}</div>
											</router-link>
										</div>
										<span class="tag" v-for="(ta,ti) in item.tags">{{ta}}</span>
									</div>
									<div class="collent">
										<Icon v-if="item.isLike" style="cursor: pointer;" size="30" type="ios-heart"
											color="#ff495e" @click="collect(item)" />
										<Icon v-else style="cursor: pointer;" size="30" type="ios-heart-outline"
											@click="collect(item)" />
										<div>{{item.like_count}}</div>
									</div>
								</div>
								
								
								<div class="avatar-div" v-if="item.publishInfo">
									<img class="avatar-img" :src="item.publishInfo.avatar | imgfilter">
									<span class="avatar-name">{{item.publishInfo.nickname}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pagination-style mt-6 mt-md-8 mt-lg-10">
					<div class="block">
						<el-pagination @current-change="handleCurrentChange" :pager-count="5"
							:current-page="currentPage" layout="total, prev, pager, next" :total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getCookies,
		removeCookies,
	} from '@/libs/util'
	import {
		getCategoryList,
		getProjectList,
		LikeAdd,
		LikeDel,
		getRecommendList
	} from '@/api'
	export default {
		name: 'app',
		data() {
			return {
				img: require('../static/images/bg/bg-2.png'),
				nameInfo: '',
				cateList: [],
				childrenIndex: 0,
				cateIndex: 0,
				cateChildrenIndex: 0,
				projectList: [],

				selcitId: 0,
				total: 0,
				currentPage: 1,
			}
		},
		created() {
			if (this.$route.query.cateId) {
				this.cateIndex = this.$route.query.cateId || 0
				this.selcitId = this.$route.query.selcitId || 0
				this.childrenIndex = this.$route.query.childrenIndex || 0
				this.cateChildrenIndex = this.$route.query.cateChildrenIndex || 0
			}
			this.getCategoryList()
		},
		computed: {
			isLogin() {
				return getCookies("webtoken");
			},
		},
		methods: {

			// 获取板块分类列表
			async getCategoryList() {
				const res = await getCategoryList()
				res.data.unshift({
					id: 0,
					cate_name: '全部',
				})
				res.data.forEach(item => {
					if (item.children) {
						item.children.unshift({
							id: 0,
							cate_name: '全部'
						})
					}
				})
				this.cateList = res.data
				if (this.selcitId > 0) {
					this.getProjectList()
				} else {
					this.getRecommendList()
				}
			},

			// 获取分类案例列表
			async getProjectList() {
				const res = await getProjectList({
					pid: this.selcitId,
					page: this.currentPage,
					limit: 9
				})
				res.data.list.forEach(e => {
					if (e.tags) e.tags = e.tags.split(',') || []
				})
				this.total = res.data.count
				this.projectList = res.data.list
			},

			// 获取推荐项目列表
			async getRecommendList() {
				const res = await getRecommendList({
					page: 1,
					limit: 9
				})
				res.data.forEach(e => {
					if (e.tags) e.tags = e.tags.split(',') || []
				})
				this.projectList = res.data
			},

			clickCate(id, index) {
				this.currentPage = 1
				this.childrenIndex = index || 0
				this.cateChildrenIndex = 0
				this.cateIndex = id
				this.selcitId = id
				if (this.selcitId > 0) {
					this.getProjectList()
				} else {
					this.getRecommendList()
				}
			},

			clickChildrenCate(id) {
				this.currentPage = 1
				if(id == 0) {
					this.selcitId = this.cateList[this.cateIndex].id
				} else {
					this.selcitId = id
				}
				this.cateChildrenIndex = id
				this.getProjectList()
			},

			handleCurrentChange(val) {
				this.currentPage = val
				this.getProjectList()
				document.documentElement.scrollTop = 0
			},

			collect(item) {
				if (!this.isLogin) {
					alert('请登录后操作')
					return false
				}
				if (item.isLike == 0) {
					LikeAdd({
						pro_id: item.id
					}).then((res) => {
						if (res.status == 200) {
							item.isLike = 1
							item.like_count++
						}
					})
				} else {
					LikeDel({
						pro_id: item.id
					}).then((res) => {
						if (res.status == 200) {
							item.isLike = 0
							item.like_count--
						}
					})
				}
			},
		}
	}
</script>

<style scoped>
	.childrenActive {
		color: #fff;
		background-color: #1e9e00;
		border-radius: 6px;
		padding: 5px 10px;
	}

	.cp:hover {
		color: #fff;
		background-color: #1e9e00;
		border-radius: 6px;
		padding: 5px 10px;
		text-decoration: none !important;
	}

	.cp:hover::after {
		display: none;
	}
	.promotion {
		display: inline-block;
		padding: 5px 20px 10px 18px;
	}
	.promotion div {
		border: 1px solid rgb(255,114,0);
		border-radius: 5px;
		color: rgb(255,114,0);
		padding: 5px 5px 2px 5px;
	}

</style>
